import React from 'react' ;
import { useNavigate } from 'react-router-dom';

import './Filieres.css';
import math from '../../asserts/images/math3.jpg' ;
import pc from '../../asserts/images/info4.jpg' ;
import elect from '../../asserts/images/elect3.jpg' ;

function Filieres() {
    const navigate = useNavigate();

  const handleClickInfo = () => {
    navigate('/departementInfo');
  };

  const handleClickMath = () => {
    navigate('/departementM');
  };

  const handleClickElectro = () => {
    navigate('/departementT');
  };

  return (
    <div className='filieres'>   
    
         <h5 >UN LARGE CHOIX DE FILIÈRES</h5>
         <div className="title">
             <h3>Bénéficiez d'une large gamme de programmes d'études et d'activités diversifiées</h3>
         </div>
         <div className="container-fluid text-center">
            <p>En ingénierie, Mastère, Licences informatiques , Mathematiques ou éléctroniques, choisissez votre futur parcours<br/> grâce à un large choix de formations.</p>
         </div>
            
            <div className="filierescard " >
                <div className='card'>
                    <div className='side side--front'>
                        <img src={pc}  alt="..." />
                        <p>INFORMATIQUES</p>
                        <p className='p2'>Ingénieurie , Mastère , Licences</p>

                    </div>
                    <div className='side side--back'>
                         <img src={pc}  alt="..." />
                         <button className='btn' onClick={handleClickInfo}>je découvre</button>
                   
                      
                    </div>
                    
                </div>
                <div className='card'>
                    <div className='side side--front'>
                        <img src={elect}  alt="..." />
                        <p>ELECTRONIQUES</p>
                        <p className='p2'>Ingénieurie , Mastère , Licences</p>

                    </div>
                    <div className='side side--back'>
                            <img src={elect}  alt="..." />
                            <button className='btn' onClick={handleClickElectro}>je découvre</button>
                            
                      
                    </div>
                    
                </div>

                <div className='card'>
                    <div className='side side--front'>
                        <img src={math}  alt="..." />
                        <p>MATHEMATIQUES</p>
                        <p className='p2'>Mastère , Licences</p>

                    </div>
                    <div className='side side--back'>
                        <img src={math}  alt="..." />
                        <button className='btn' onClick={handleClickMath}>je découvre</button>
                       
                      
                    </div>
                    
                </div>
               
               
               
            </div>
         
    </div>
  )
}

export default Filieres